module.exports = __webpack_public_path__ + "static/media/pre_owned_title_en@3x.a2d21daa.png";